import { all } from "redux-saga/effects";
import configSyncSaga from "./configSync/confygSyncSaga";
import { brandsSectionSaga } from "redux/ducks/brandsSection";
import { crmSaga } from "redux/sagas/crmSagas";
import { dispensersSaga } from "redux/ducks/dispensers";
import { changePasswordSaga } from "redux/ducks/changePassword";
import { giotanksSaga } from "redux/ducks/giotanks";
import { giotanksGraphSaga } from "redux/ducks/giotanksGraph";
import { pricesSectionSaga } from "redux/ducks/pricesSection";
import { pricesBusinessSaga } from "redux/ducks/pricesBusinessSection";
import { profitStationSaga } from "redux/ducks/profitStation";
import { unitsSectionSaga } from "redux/ducks/unitsSection";
import { updatePriceSaga } from "redux/ducks/updatePrice";
import { mapPageSaga } from "redux/ducks/mapPage";
import { loginSaga } from "redux/ducks/login";
import { resetPasswordSaga } from "redux/ducks/resetPassword";
import { ordersSaga } from "redux/ducks/orders";
import { ordersHistorySaga } from "redux/ducks/ordersHistory";
import { ordersGraphSaga } from "redux/ducks/ordersGraph";
import { pipesSeriesSaga } from "redux/ducks/pipesSeries";
import { categoriesSaga } from "redux/ducks/expenses";

// news
import { newBrandSaga } from "../ducks/newBrand";
import { newBrandSaleSaga } from "../ducks/newBrandSale";
import { newBrandStationSaga } from "../ducks/newBrandStation";

export default function* rootSaga() {
  yield all([
    mapPageSaga(),
    configSyncSaga(),
    changePasswordSaga(),
    brandsSectionSaga(),
    crmSaga(),
    dispensersSaga(),
    giotanksSaga(),
    giotanksGraphSaga(),
    pricesSectionSaga(),
    pricesBusinessSaga(),
    profitStationSaga(),
    unitsSectionSaga(),
    updatePriceSaga(),
    loginSaga(),
    ordersSaga(),
    ordersHistorySaga(),
    ordersGraphSaga(),
    pipesSeriesSaga(),
    categoriesSaga(),

    // news
    newBrandSaga(),
    newBrandSaleSaga(),
    newBrandStationSaga(),
    resetPasswordSaga(),
  ]);
}
